import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import useAxios from '../../Hooks/useAxios';
import { getActiveProcesses } from "../../Components/RMCActiveProcess/RMCActiveProcess";
//CC NEW 2026-10-15 10:23
import { getWorkingDaysDifference } from "../../Utils/date.util.js";
//CC NEW 2026-10-15 10:23
import { STATUS_RESOLVED, NO_DELAYS_MESSAGE } from "../../Constants/Global";

/**
 * Component for displaying the top metric cards in the Reports view.
 * Currently in placeholder state.
 * * @component
 */

const parseISOString = (dateString) => {
    if (!dateString) return new Date();
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
};


class ProcessMetric {
  constructor(id, startDate, endDate) {
    this.id = id; // número entero
    this.strStartDate = startDate;
    this.strEndDate = endDate;
    //this.startDate = new Date(startDate); // fecha inicio
    //this.endDate = new Date(endDate);     // fecha fin
  }

  // método que calcula días entre fechas
  getOnboardingTime() {
    const diffMs = this.endDate - this.startDate; // diferencia en milisegundos
    const diffDays = diffMs / (1000 * 60 * 60 * 24); // convertir a días
    return Math.floor(diffDays);
  }
}



function isEarlier(dateStr1, dateStr2) {
  // Convertimos los strings "aaaa-mm-dd" a objetos Date
  const date1 = new Date(dateStr1);
  const date2 = new Date(dateStr2);

  // Comparamos
  if (date1 < date2) {
    return 1; // la primera es anterior
  } else {
    return 0; // no lo es
  }
}




//CC NEW 2026-10-15 10:23
//$$ Tarea resuelta con la mayor desviacion sobre su duracion prevista.
//$$ Devuelve su nombre, o null si ninguna supera su default_duration.
const findCritical = (dataFiltered) => {

    if (!Array.isArray(dataFiltered)) return null;

    //$$ Solo los procesos presentes en la lista filtrada
    const visibleLabels = new Set(
        Array.isArray(dataFiltered) ? dataFiltered.map((row) => row.label) : []);

    const mDeviations = new Map();

    dataFiltered.forEach((row) => {

        //if (!visibleLabels.has(row.label)) return;

        if (row.statusId !== STATUS_RESOLVED) return;

        if (!row.inProcessAt || !row.resolvedAt) return;

        const iDefaultDuration = Number(row.defaultDuration);

        if (!Number.isFinite(iDefaultDuration)) return;

        //$$ Dias laborables que costo de verdad la tarea
        const iWorkingDays = getWorkingDaysDifference(
                parseISOString(row.inProcessAt),
                parseISOString(row.resolvedAt));

        if (iWorkingDays > iDefaultDuration)
            mDeviations.set(row.id, iWorkingDays - iDefaultDuration);
    });

    if (mDeviations.size === 0) return null;

    //$$ El id con la desviacion mayor
    let iCriticalId = null;
    let iMaxDeviation = -Infinity;

    mDeviations.forEach((iDeviation, iId) => {
        if (iDeviation > iMaxDeviation) {
            iMaxDeviation = iDeviation;
            iCriticalId = iId;
        }
    });

    const criticalSubprocess = dataFiltered.find((row) => row.id === iCriticalId);

    return criticalSubprocess ? criticalSubprocess.name : null;
};


//$$ card text
const text1 = "Processes on time/let";
const text2 = "Average onboarding time";
const text3 = "Critical point";



//$$ Getting process from api
 const GetProcesses2 = (strDept, data) => {

    let strEarliest = "";
    let earlierEndDate = "";
    let index = 0;

    let text1 = "";
    let text2 = "";
    let text3 = "";

    let activeProcesses = getActiveProcesses();
    //console.log("activeProcesses:", activeProcesses);

    console.log("data_subprocess:", data);

    //$$ data is a process array
    if (data && Array.isArray(data)) {


        console.log("searchTerm:", strDept);

        let iNumActiveProcesses = 0;
        let iNumLateProcesses = 0;
        const today = new Date();

       //$$ Loop for every process in data
       data.forEach((row) => {

            activeProcesses.forEach((process) => {

                if (row.label === process.id ) {
                     if (row.statusId === 1 || row.statusId === 2) {

                                //console.log("searchTerm2:", strDept);
                                //console.log("row.name:", row.name);

                                //$$ Finding the earliest pending subprocess
                               if (index == 0 || (isEarlier(row.endDate, earlierEndDate)) == 1)
                                {

                                    earlierEndDate = row.endDate;

                                    strEarliest = row.name;
                                    //console.log("row.name2:", row.name);

                                }

                          index ++;


                          text3 = strEarliest;
                          //console.log("text3:", text3);
                     }

                }

            });

       });

    }

    //$$ Emptying array and removing references
    activeProcesses = [];
    activeProcesses = null;

    return { text1, text2, text3 };
 }


 //$$ Getting process from api
  const GetProcesses = (strDept, data) => {

     //CC NEW 2026-10-15 10:40
     //$$ Lista completa de subprocesos; data solo trae los que pasan los filtros
     //const { data: dataSubprocesses } = useAxios("allSubprocessesDetails");

     let text1 = "";
     let text2 = "";
     let text3 = "";

     //CC NEW 2026-10-15 10:40
     //$$ Tarea resuelta con la mayor desviacion sobre su duracion prevista
     const critical = findCritical(data);

     text3 = critical !== null ? critical : NO_DELAYS_MESSAGE;

     return { text1, text2, text3 };
  }


const RMCCriticalPoint= ({ strDepartment, data }) => {

  const { text1, text2, text3 } = GetProcesses(strDepartment, data);
   const getCard1Text = () => text1;
   const getCard2Text = () => text2;
   const getCard3Text = () => text3;

  // functions array
  const cardFunctions = [getCard3Text];

  //$$ Cards number 1 per function
  const cardNumber = cardFunctions.length;

  return (

  <div
        style={{
          display: 'grid',
          // This will change the width of the card dynamically for fixing the grid width
          gridTemplateColumns: `repeat(${cardNumber}, 1fr)`,

          gap: '16px'
        }}
      >
        {/*//$${[1, 2, 3].map((i) => (*/}
        { cardFunctions.map((fn,i) => (
          <Paper
            key={i}
            elevation={0}
            sx={{
              p: 2,
              border: '1px solid #ccc',
              display: 'flex',
              flexDirection: "column",
              //justifyContent: 'center',
              //alignItems: 'center',
              bgcolor: '#f9f9f9',
              borderRadius: 2,
              height: 120
            }}
          >

          <Typography
                  variant="h6"
                  sx={{ textAlign: "left", mb: 2 }}

                >
                  Critical point
                </Typography>

                <Typography
                        variant="h5"
                        sx={{
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        {fn()}
                      </Typography>


          </Paper>
        ))}
      </div>

  );
};

export default RMCCriticalPoint;